











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArchiveOrganization_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArchiveOrganizationForm_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node ).hash = "fcb5fe1a51478d4dc5a868a17b5a79b1";

export default node;
